import { t } from '@i18n';
import { mergeThemes } from 'schummar-table';
import { mantineTheme } from 'schummar-table/mantineTheme';

export default mergeThemes(mantineTheme, {
  text: {
    selectColumns: t('table.selectColumns'),
    showAllColumns: t('table.showAllColumns'),
    hideAllColumns: t('table.hideAllColumns'),
    noResults: t('table.noResults'),
    exportTitle: t('table.exportTitle'),
    exportCopy: t('table.exportCopy'),
    exportDownload: t('table.exportDownload'),
    today: t('table.today'),
    thisWeek: t('table.thisWeek'),
    thisMonth: t('table.thisMonth'),
    thisYear: t('table.thisYear'),
    lastSevenDays: t('table.lastSevenDays'),
    lastThirtyDays: t('table.lastThirtyDays'),
    reset: t('table.reset'),
    loading: t('table.loading'),
    clearFilters: t('table.clearFilters'),
    deselectAll: t('table.deselectAll'),
    resetAll: t('table.resetAll'),
    rangeMin: t('table.rangeMin'),
    rangeMax: t('table.rangeMax'),
    calendarWeek: t('table.calendarWeek'),
    hiddenColumnFilters: t('table.hiddenColumnFilters'),
  },
  colors: {
    background: 'var(--mantine-color-paper-7)',
    text: 'inherit',
    border: 'var(--mantine-color-paper-9)',
    borderLight: 'var(--mantine-color-paper-8)',
  },
  styles: {
    headerCell: {
      transform: 'var(--app-shell-header-transform)',
      transitionDuration: 'var(--app-shell-transition-duration)',
      transitionProperty: 'transform',
    },
    cell: {
      '&:not(:empty)': {
        paddingTop: '0.5em',
        paddingBottom: '0.5em',
      },
    },
  },
});
